import {getMerchantAudience, getMerchantFacebookPixel} from "./PublicData";
import {iframeToSdkChannel} from "../messaging/IframeToSdkChannel";
import {IFrameMessages} from "../messaging/IFrameMessages";
import {FLOW_CHECKPOINT, FLOW_TYPE} from "../Constants";


// TODO @cleanup Fucking shit balls Darius added this Facebook cancer and it must be purged from our SDK
class FacebookPixelModule {
    init() {
        const facebookPixel = getMerchantFacebookPixel();
        if (!facebookPixel) {
            return;
        }

        this.initFBQ(facebookPixel.pixelId);

        iframeToSdkChannel.addListener(IFrameMessages.FLOW_CHECKPOINT, ({event, extra}) => {
            if (event.flowCheckpoint !== FLOW_CHECKPOINT.complete) {
                return;
            }
            if (event.flowType === FLOW_TYPE.subscription) {
                this.submit(facebookPixel.subscriptionConversionEvent, event, `subscription-${event.subscriptionId}`);
            } else if (event.flowType === FLOW_TYPE.newsletter) {
                if (!extra || !extra.audienceMembers) {
                    return;
                }
                for (const audienceMember of extra.audienceMembers) {
                    const audience = getMerchantAudience(audienceMember.audienceId);
                    if (audience && audienceMember.status === "self_subscribed" && audienceMember.subscribedAt) {
                        this.submit(facebookPixel.newsletterConversionEvent, {
                            newsletter: audience.name,
                        }, `newsletter-${audienceMember.id}-${Math.round(+(new Date(audienceMember.subscribedAt)) / 1000)}`);
                    }
                }
            } else if (event.flowType === FLOW_TYPE.donation) {
                this.submit(facebookPixel.donationConversionEvent, event, `donation-${event.donationId}`);
            }
        })
    }

    submit(conversionEventDescription, event, eventId) {
        if (!conversionEventDescription) {
            return;
        }
        const eventName = conversionEventDescription.name;
        const trackType = conversionEventDescription.trackType;
        const fbqPayload = {};
        for (const key of Object.keys(conversionEventDescription.builtinCustomProperties || {})) {
            fbqPayload[key] = String(event[conversionEventDescription.builtinCustomProperties[key]] ?? "");
        }
        Object.assign(fbqPayload, conversionEventDescription.extraCustomProperties || {});
        fbq(trackType, eventName, fbqPayload, {
            eventID: eventId,
        });
    }

    initFBQ(pixelId) {
        if (window.fbq) {
            return;
        }

        window.fbq = function () {
            if (fbq.callMethod) {
                fbq.callMethod.apply(fbq, arguments);
            } else {
                fbq.queue.push(arguments);
            }
        }
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = "2.0";
        fbq.queue = [];
        window._fbq = window._fbq || fbq;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        fbq("init", pixelId);
        fbq("track", "PageView");
    }
}

export const facebookPixelModule = new FacebookPixelModule();
